<template>
    <div>
        <div class="voucher-header border-line">
            <div class="voucher-container mx-auto">
                <div class="text-center text-16 text-a-gray-666666">
                    <div class="font-SemiBold text-a-black-080909">Select option to redeem</div>
                </div>
            </div>
        </div>
        <div class="voucher-container mx-auto pb-24 gap-3 flex flex-col">
            <!-- Qr Code With Amount -->
            <div class="flex flex-wrap space-x-2 px-5 py-2" @click="selectState('qrcodeamount')">
                <div class="flex items-center gap-3 w-full">
                    <img src="../../assets/icon/ic-qr-with-amount.svg" alt="qr icon">
                    <div class="w-full">
                        <span class="text-a-gray-666666 text-16">QR Code With Amount</span>
                        <div class="text-a-gray-aaaaaa text-14">Generate QR code by entering the quantity of points</div>
                    </div>
                    <div>
                        <img src="../../assets/icon/ic-caret-right.svg" alt="go qr amount">
                    </div>
                </div>
            </div>
            <!-- Qr Code Without Amount -->
            <div class="flex flex-wrap space-x-2 px-5 py-2" @click="selectState('qrcodewithouteamount')">
                <div class="flex items-center gap-3 w-full">
                    <img src="../../assets/icon/ic-qr-without-amount.svg" alt="qr icon">
                    <div class="w-full">
                        <span class="text-a-gray-666666 text-16">QR Code Without Amount</span>
                        <div class="text-a-gray-aaaaaa text-14">Generate QR code without to enter the quantity of points</div>
                    </div>
                    <div>
                        <img src="../../assets/icon/ic-caret-right.svg" alt="go qr amount">
                    </div>
                </div>
            </div>
            <!-- Scan QR Code -->
            <div class="flex flex-wrap space-x-2 px-5 py-2" @click="selectState('scanqr')">
                <div class="flex items-center gap-3 w-full">
                    <img src="../../assets/icon/ic-scan-qr.svg" alt="scan qr icon">
                    <div class="w-full">
                        <span class="text-a-gray-666666 text-16">Scan QR Code</span>
                        <div class="text-a-gray-aaaaaa text-14">Scan to use points only</div>
                    </div>
                    <div>
                        <img src="../../assets/icon/ic-caret-right.svg" alt="go qr amount">
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { onMounted} from "vue"
export default {
    name: 'Voucher',
    props: {
        lbl: Object,
        blobConfig: { type: Object },
        rate: { type: Object },
        modalController: { type: Object },
    },
    components: {
    },
    setup: function (props, ctx) {
        

        const selectState = (state) => {
            ctx.emit('selectState', state);
        }

        onMounted(()=> {

        })

        return {
            selectState
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../style/base.scss';

.voucher-container {
    min-height: max-content;
    max-width: $max-width-l-mobile;
}
.voucher-header {
    padding: 66px 0 14px;
    @include tablet {
        padding: 60px 0 14px;
    }
}
.font-SemiBold {
    font-family: $ff-semi;
}
.font-Text {
    font-family: $ff-text;
}
.border-line {
    border-bottom: 2px dashed;
    border-color: #cccccc;
}
</style>
